import React from 'react';
import Badge from '../Badge/Badge';
import Tooltip from '../Tooltip';

interface RedFlagBadgeProps {
  visible?: boolean | null;
  className?: string;
}

const RedFlagBadge: React.FC<RedFlagBadgeProps> = ({ visible, className }) => {
  if (!visible) {
    return null;
  }

  return (
    <Tooltip content="Os dois últimos treinos entregues têm o mesmo código">
      <Badge variant="danger" solid className={className}>
        Atenção no treino
      </Badge>
    </Tooltip>
  );
};

export default RedFlagBadge;
